import { createI18n } from 'vue-i18n'
import { languageMap } from './languages'
import storage from 'store2'
// import { useLanguageStore } from '@/stores'
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  messages: {}
})

// 动态设置语言
export async function setLanguage(value) {
  let lang = value || storage.get('locale') || 'en'

  if (!languageMap[lang]) return console.warn(`语言 ${lang} 未定义！`)

  storage.set('locale', lang)

  const msgModule = await languageMap[lang]()
  const messages = msgModule.default

  // 更新 i18n 的语言
  i18n.global.setLocaleMessage(lang, messages)
  i18n.global.locale.value = lang

  document.documentElement.lang = lang;
}

export default i18n

// 使得 `$t` 在全局可用
export const $t = (e,params) => i18n.global.t(e,params)
